import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccVentureDropout } from '../venture-dropouts-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccVentureDropout, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName', width: 30 }),
		buildColumn(util, 'FullName', row => row.facilitatorName, { header: 'PF Name', hidden: true }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name', width: 60 }),
		buildColumn(util, 'Number', row => row.dropoutWeek, { header: 'Dropout Week', width: 30 }),
		buildColumn(util, 'Text', row => row.dropoutReason, { header: 'Dropout Reason', width: 60 }),
		buildColumn(util, 'Text', row => row.notes, { header: 'Notes' }),
	];


	return columns;

}